import { useState } from 'react'
import type { RenderableCategoryFilterOption } from 'shared/types/util'
import { useSelector } from 'react-redux'
import { BasicCollapsible } from '@vp/swan'

import { FilterCheckboxList } from '~/app/features/Gallery/components/Filters/Shared/FilterCheckboxList'
import { ShowMoreButton } from '~/app/features/Gallery/components/Filters/Shared/ShowMoreButton'
import { categoryOptionsSelectorFactory } from '~/app/features/Gallery/components/Filters/util'
import { REFINEMENT_DIMENSION } from '~/shared/constants'
import type { State } from 'shared/types/gallery/state'

export interface PropTypes {
  filter: State.Filter
}

export const FlatTaxonomy = (props: PropTypes) => {
  const { filter } = props

  const f = filter as State.CategoryFilter
  const [showMore, setShowMore] = useState(false)

  const { options, selectedValues, visible } = useSelector(categoryOptionsSelectorFactory(f.categoryId.toString(), false))

  // if there's no bestselling count, set it to a really high number so everything is rendered
  const bestSellingCount = f.bestSellingCount || Number.MAX_SAFE_INTEGER
  const shouldShowCategory = (o: RenderableCategoryFilterOption): boolean => showMore || !o.rank || o.rank < bestSellingCount

  return visible ? (
    <BasicCollapsible aria-label={f.title} className="filter" collapsibleId={filter.name} heading={f.title} headingLevel="h4">
      <FilterCheckboxList
        options={options}
        refinementDimension={REFINEMENT_DIMENSION.CATEGORY}
        selectedValues={selectedValues}
        shouldShowFilterOption={shouldShowCategory}
        title={f.title}
      />

      {options.length > bestSellingCount && <ShowMoreButton showMore={showMore} title={filter.title} onClick={(): void => setShowMore(!showMore)} />}
    </BasicCollapsible>
  ) : null
}

FlatTaxonomy.displayName = 'FlatTaxonomy'
